'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import CardTillamaps from 'components/cards/CardTillamaps';
import Grid from 'components/ui/Grid';

import { blockRootProps } from 'utils';

import styles from './BlockFoodServiceContactForm.module.scss';

const BlockFoodServiceContactForm = ({
    __typename,
    card,
    formId,
    flushTop,
    flushBottom,
}) => {
    const [wrapperHeight, updateWrapperHeight] = useState(0);

    useEffect(() => {
        const handleMessage = msg => {
            if (msg?.origin === `https://${formId}.paperform.co`) {
                try {
                    const parsedData = JSON.parse(msg?.data || '{}') || null;
                    const height = parsedData?.height || null;

                    if (height) {
                        updateWrapperHeight(height);
                    }
                } catch {}
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [formId]);

    return (
        <div
            {...blockRootProps(null, __typename)}
            className={cx(styles.contact, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
        >
            <Grid>
                <div className={styles.contactInner}>
                    <div
                        style={{ height: wrapperHeight, width: '100%' }}
                        className={styles.iframeWrapper}
                    >
                        <iframe
                            title={`Contact Form`}
                            scrolling="no"
                            frameBorder="0"
                            width="100%"
                            src={`https://${formId}.paperform.co?embed=1&inline=1`}
                            height="100%"
                        ></iframe>
                    </div>
                </div>
                <CardTillamaps {...card} />
            </Grid>
        </div>
    );
};

BlockFoodServiceContactForm.propTypes = {
    __typename: PropTypes.string,
    card: PropTypes.object.isRequired,
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    formId: PropTypes.string.isRequired,
};

export default BlockFoodServiceContactForm;
